import { render, staticRenderFns } from "./AdminRecentIssues.vue?vue&type=template&id=7d9d3aa3&"
import script from "./AdminRecentIssues.vue?vue&type=script&lang=ts&"
export * from "./AdminRecentIssues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports